import { DadosMovimentacaoManutencao } from "../model/entities/ProgramaManutencao";
import api from "./api";

const ROUTE = "movimentacao_manutencao";

class movimentacaoManutencaoApi {
  async getById(id: number) {
    try {
      const res = await api.get<DadosMovimentacaoManutencao>(`/${ROUTE}/${id}`);
      const data = res.data;

      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
  async getMany(
    pagina: number,
    linhasPorPagina: number,
    campoOrdenacao: string = "id",
    direcao: "asc" | "desc" = "asc",
    filtros?: {
      dataInicial?: string;
      dataFinal?: string;
      placa?: string;
      status?: string;
    }
  ) {
    try {
      const params = new URLSearchParams();

      params.append("size", String(linhasPorPagina));
      params.append("page", String(pagina));
      params.append("sort", `${campoOrdenacao},${direcao}`);

      if (filtros?.dataInicial)
        params.append("dataInicial", filtros.dataInicial);
      if (filtros?.dataFinal) params.append("dataFinal", filtros.dataFinal);
      if (filtros?.placa) params.append("placa", filtros.placa);
      if (filtros?.status) params.append("status", filtros.status);

      const res = await api.get(`/${ROUTE}?${params.toString()}`);

      return res.data;
    } catch (error: any) {
      console.error("Erro ao buscar movimentações:", error);
      throw error;
    }
  }

  async count() {
    try {
      const res = await api.get<number>(`/${ROUTE}/count`);
      const data = res.data;
      return data;
    } catch (error: any) {
      console.log(error);
      throw error;
    }
  }
}

const apiMovimentacaoManutencao = new movimentacaoManutencaoApi();
export default apiMovimentacaoManutencao;
